module.exports = __webpack_public_path__ + "app-static/img/face-1.88d212a2.png";